import React, { forwardRef } from 'react';
import styled from 'styled-components';

import Italian from '../../assets/images/countries/it.svg';
import English from '../../assets/images/countries/en.svg';
import Korean from '../../assets/images/countries/kr.svg';
import Japanese from '../../assets/images/countries/jp.svg';
import French from '../../assets/images/countries/fr.svg';
import Filipino from '../../assets/images/countries/tl.svg';
import UpArrow from '../../assets/icons/up-arrow.svg';

const FloatingWrapper = styled.div`
  display: flex;
  align-items: center;
  -webkit-align-items: center;
  position: fixed;
  z-index: 10;
  bottom: 0;
  right: 5.5rem;
  background-color: #ced6e0;
  padding: 0.25rem 1rem;
  border-radius: 3px 3px 0 0;
  :hover {
    cursor: pointer;
  }

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    display: none !important;
  }
`;

const ActiveLangImg = styled.img`
  height: 1.5rem;
`;

const ArrowImg = styled.img`
  height: 2rem;
  width: 2rem;
`;

const returnCountryImage = (lang) => {
  if (lang === 'en') return English;
  else if (lang === 'it') return Italian;
  else if (lang === 'kr') return Korean;
  else if (lang === 'jp') return Japanese;
  else if (lang === 'tl') return Filipino;
  else if (lang === 'fr') return French;
  else return English;
};

const LanguageFooter = forwardRef((props, ref) => (
  <FloatingWrapper
    style={props.style}
    ref={ref}
    onClick={() => props.openLangMenu()}
    aria-controls={props.open ? 'lang-menu-list-grow' : undefined}
    aria-haspopup='true'
  >
    <ActiveLangImg src={returnCountryImage(props.lang)} alt='country-flag' />
    <ArrowImg src={UpArrow} alt='arrow-up' />
  </FloatingWrapper>
));

export default LanguageFooter;
